export default __webpack_public_path__ + "static/media/fondo-provisional.67887fcf.jpg";